import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Text } from '@soluto-private/mx-asurion-ui-react';

type Props = {
  description: string;
  title: string;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TextWrapper = ({
  description,
  title,
}: PropsWithChildren<Props>) => {
  return (
    <Container>
      <Text size={2} weight="heavy">
        {title}
      </Text>
      <Text size={2} weight="base">
        {description}
      </Text>
    </Container>
  );
};
